import RMFReport2 from './RMFReport2';

const uncdfreports2 = {
  list: RMFReport2
};

export default uncdfreports2;
